module.exports = __webpack_public_path__ + "img/team-dark-01.8f312446.jpg";